<template>
  <v-container class="pa-0"  fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import PreparedSentMessageForm from '@/views/messages/preparedSentMessages/PreparedSentMessageForm'
import PreparedSentMessages from '@/views/messages/preparedSentMessages/PreparedSentMessages'
export default {
  name: 'errorsCorrectionTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Pranešimas',
          route: 'errorsCorrectionNew',
          component: PreparedSentMessageForm
        },
        {
          title: 'Pranešimas',
          route: 'errorsCorrectionListNew',
          component: PreparedSentMessageForm
        },
        {
          title: 'Rengiami ir pateikti klaidų taisymai',
          route: 'errorsCorrectionList',
          component: PreparedSentMessages,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
